import { render, staticRenderFns } from "./swiperConfig.vue?vue&type=template&id=280c085a&scoped=true"
import script from "./swiperConfig.vue?vue&type=script&lang=js"
export * from "./swiperConfig.vue?vue&type=script&lang=js"
import style0 from "./swiperConfig.vue?vue&type=style&index=0&id=280c085a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c085a",
  null
  
)

export default component.exports